import React from "react";

const LeftArrowIcon = ({
  className = "",
  width = "6",
  height = "10",
  color = "black",
  restProps,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...restProps}
    >
      <path
        d="M5.58129 9.29766C5.66412 9.29764 5.74509 9.27716 5.81396 9.23879C5.88282 9.20043 5.93648 9.14591 5.96816 9.08212C5.99984 9.01834 6.00811 8.94817 5.99193 8.88047C5.97574 8.81277 5.93583 8.75059 5.87724 8.70179L1.01104 4.64663L5.87724 0.591457C5.95353 0.525635 5.99574 0.437476 5.99479 0.345969C5.99383 0.254462 5.94979 0.166928 5.87214 0.10222C5.79449 0.0375125 5.68945 0.000808365 5.57964 1.31932e-05C5.46983 -0.000781979 5.36404 0.0343954 5.28505 0.0979689L0.12262 4.4C0.044107 4.46544 0 4.5542 0 4.64674C0 4.73928 0.044107 4.82804 0.12262 4.89349L5.28505 9.19551C5.32396 9.22792 5.37015 9.25362 5.42098 9.27114C5.47181 9.28867 5.52628 9.29768 5.58129 9.29766Z"
        fill={color}
      />
    </svg>
  );
};

export default LeftArrowIcon;
